var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('section-benefits',{attrs:{"content":_vm.sectionBenefits}}),_c('section-function',{attrs:{"content":_vm.sectionFunction}}),_c('section-acum',{attrs:{"content":_vm.sectionAcum}}),_c('section-collection',{attrs:{"content":_vm.SectionColection}}),_c('section-mark',{attrs:{"content":_vm.SectionMark}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }